import { CellAction } from './cell-action';

import { ColumnDef } from '@tanstack/react-table';
import { showDate } from '../../../lib/dateFormater';
import { Badge } from '../../ui/badge';
import { Eye } from 'lucide-react';

const uploadUrl = process.env.REACT_APP_FILE_UPLOAD;

const FileViewButton = ({ file, label }: { file: string | null; label: string }) => {
  if (!file) {
    return <span className="text-xs text-gray-400 italic">Non fourni</span>;
  }
  const fileUrl = `${uploadUrl}/application/${encodeURIComponent(file)}`;
  return (
    <a
      href={fileUrl}
      target="_blank"
      rel="noopener noreferrer"
      title={`Voir ${label} : ${file}`}
      className="inline-flex items-center gap-1.5 px-2.5 py-1.5 rounded-md text-xs font-medium bg-blue-50 text-blue-700 border border-blue-200 hover:bg-blue-100 hover:border-blue-300 transition-colors cursor-pointer"
    >
      <Eye className="w-3.5 h-3.5" />
      {label}
    </a>
  );
};

export const columns: ColumnDef<any>[] = [
  {
    accessorKey: 'reference',
    header: 'REFERENCE',
    cell: ({ row }) => {
      return (
        row.original.reference || <span className="text-xs text-gray-400 italic">Spontanée</span>
      );
    },
  },

  {
    accessorKey: 'firstName',
    header: 'NOM & PRENOM',
    cell: ({ row }) => {
      const { firstName, lastName } = row.original;
      return `${firstName} ${lastName}`;
    },
  },
  {
    accessorKey: 'email',
    header: 'EMAIL',
  },
  {
    accessorKey: 'phone',
    header: 'TÉLÉPHONE',
  },
  {
    accessorKey: 'resume',
    header: 'CV',
    cell: ({ row }) => {
      return <FileViewButton file={row.original.resume} label="Voir CV" />;
    },
  },
  {
    accessorKey: 'coverLetter',
    header: 'LETTRE DE MOTIVATION',
    cell: ({ row }) => {
      return <FileViewButton file={row.original.coverLetter} label="Voir lettre" />;
    },
  },
  {
    accessorKey: 'date',
    header: 'DATE',
    cell: ({ row }) => {
      return showDate(row.original.createdAt);
    },
  },
  {
    accessorKey: 'type',
    header: 'TYPE',

    cell: ({ row }) => {
      return (
        <Badge
          className={`${row.original.type === 'classique' ? 'bg-green-500' : 'bg-orange-500'} `}
        >
          {row.original.type}
        </Badge>
      );
    },
  },

  {
    accessorKey: 'actions',
    header: 'ACTIONS',
    id: 'actions',
    cell: ({ row }) => <CellAction data={row.original} />,
  },
];
